import React from "react";
import { useNavigate } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const CleaningSuccess: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.circle}>
          <CheckCircleIcon style={{ fontSize: 60, color: "#fff" }} />
        </div>

        <h2 style={styles.title}>Booking Confirmed</h2>
        <p style={styles.subtitle}>
          Your cleaning service was successfully booked!
        </p>

        <button
          style={styles.doneButton}
          onClick={() => navigate("/")}
        >
          Go Home
        </button>
      </div>
    </div>
  );
};

export default CleaningSuccess;

/* 💅 Green-themed styles */
const styles: { [key: string]: React.CSSProperties } = {
  page: {
    minHeight: "100vh",
    backgroundColor: "#f0fdf4",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "Poppins, sans-serif",
    padding: "2rem",
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: 20,
    padding: "2.5rem 2rem",
    width: "95%",
    maxWidth: 420,
    textAlign: "center",
    boxShadow: "0 10px 40px rgba(22,163,74,0.15)",
    border: "1px solid rgba(22,163,74,0.35)",
    transition: "all 0.4s ease",
  },
  circle: {
    width: 90,
    height: 90,
    borderRadius: "50%",
    background: "linear-gradient(135deg, #4ade80 0%, #16a34a 40%, #14532d 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 1.5rem auto",
    boxShadow: "0 6px 16px rgba(22,163,74,0.4)",
  },
  title: {
    color: "#14532d",
    fontSize: "1.6rem",
    fontWeight: 700,
    marginBottom: "0.8rem",
  },
  subtitle: {
    color: "#555",
    fontSize: "0.95rem",
    marginBottom: "2rem",
  },
  doneButton: {
    background: "linear-gradient(135deg, #4ade80 0%, #16a34a 40%, #14532d 100%)",
    color: "#fff",
    border: "none",
    borderRadius: 30,
    padding: "12px 40px",
    fontSize: "1rem",
    fontWeight: 700,
    cursor: "pointer",
    transition: "all 0.25s ease",
    boxShadow: "0 6px 18px rgba(22,163,74,0.3)",
  },
};